<template>
  <a-card :bordered='false'>
    <!-- 查询区域 -->
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('label.batchNo')">
              <j-input :placeholder="$t('label.pleaseSelectBatchNo')" v-model='queryParam.breedCode'></j-input>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('button.search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload'
                        style='margin-left: 8px'>{{ $t('button.reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class='table-operator'>
      <a-button @click='handleAdd' type='primary' icon='plus'>{{ $t('button.add') }}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('efs_md_bill')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
      <!--<j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>-->
      <a-dropdown v-if='selectedRowKeys.length > 0'>
        <a-menu slot='overlay'>
          <a-menu-item key='1' @click='batchDel'>
            <a-icon type='delete' />
            {{ $t('button.delete') }}
          </a-menu-item>
        </a-menu>
        <a-button style='margin-left: 8px'> 批量操作
          <a-icon type='down' />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class='ant-alert ant-alert-info' style='margin-bottom: 16px;'>
        <i class='anticon anticon-info-circle ant-alert-icon'></i> {{ $t('tip.selected') }} <a style='font-weight: 600'>{{
          selectedRowKeys.length }}</a>{{ $t('tip.term') }}
        <a style='margin-left: 24px' @click='onClearSelected'>{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref='table'
        size='middle'
        bordered
        rowKey='id'
        class='j-table-force-nowrap'
        :scroll='{x:true}'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        :rowSelection='{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}'
        @change='handleTableChange'>

        <template slot='htmlSlot' slot-scope='text'>
          <div v-html='text'></div>
        </template>

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
<!--        <template slot='imgSlot' slot-scope='text'>-->
<!--          <span v-if='!text' style='font-size: 12px;font-style: italic;'>无图片</span>-->
<!--          <img v-else :src='getImgView(text)' height='25px' alt=''-->
<!--               style='max-width:80px;font-size: 12px;font-style: italic;' />-->
<!--        </template>-->
<!--        <template slot='fileSlot' slot-scope='text'>-->
<!--          <span v-if='!text' style='font-size: 12px;font-style: italic;'>无文件</span>-->
<!--          <a-button-->
<!--            v-else-->
<!--            :ghost='true'-->
<!--            type='primary'-->
<!--            icon='download'-->
<!--            size='small'-->
<!--            @click='downloadFile(text)'>-->
<!--            下载-->
<!--          </a-button>-->
<!--        </template>-->

        <span slot='action' slot-scope='text, record'>
          <a @click='handleEdit(record)' v-if="record.status =='10'">{{ $t('button.edit') }}</a>

          <a-divider type='vertical' v-if="record.status =='10'"/>
          <a-dropdown>
            <a class='ant-dropdown-link'>{{ $t('button.more') }} <a-icon type='down' /></a>
            <a-menu slot='overlay'>
              <a-menu-item v-if="record.status =='10'">
                  <a-popconfirm :title="$t('tip.isSubmit')" @confirm='() => handleSubmit(record.id)'>
                    <a>{{ $t('button.submit') }}</a>
                  </a-popconfirm>
                </a-menu-item>
              <a-menu-item v-if="record.status =='30'">
              <a-popconfirm :title="$t('tip.isWriteOff')" @confirm='() => handleReserve(record.id)'>
                <a>{{ $t('button.writeOff') }}</a>
              </a-popconfirm>
            </a-menu-item>
              <a-menu-item>
                <a @click='handleDetail(record)'> {{ $t('button.details') }}</a>
              </a-menu-item>
              <a-menu-item v-if="record.status =='10'">
                <a-popconfirm :title="$t('tip.isDelete')" @confirm='() => handleDelete(record.id)'>
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-st-breed-settle-modal ref='modalForm' @ok='modalFormOk' />
  </a-card>
</template>

<script>

import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import EfsStBreedSettleModal from './modules/EfsStBreedSettleModal'
import '@/assets/less/TableExpand.less'
import { postFormAction } from '@/api/manage'

export default {
  name: 'EfsStBreedSettleList',
  mixins: [JeecgListMixin],
  components: {
    EfsStBreedSettleModal
  },
  data() {
    return {
      description: 'efs_md_bill管理页面',
      // 表头
      columns: [
        {
          slotName: 'tableHeader.documentNo',
          align: 'center',
          dataIndex: 'code',
          scopedSlots: { title: 'tableHeader.documentNo' }
        },
        {
          slotName: 'tableHeader.batchNo',
          scopedSlots: { title: 'tableHeader.batchNo' },
          align: 'center',
          dataIndex: 'breedBatchCode'
        },
        {
          slotName: 'tableHeader.contractNo',
          scopedSlots: { title: 'tableHeader.contractNo' },
          align: 'center',
          dataIndex: 'conCode'
        },
        {
          slotName: 'tableHeader.settlementDate',
          scopedSlots: { title: 'tableHeader.settlementDate' },
          align: 'center',
          dataIndex: 'settleDate',
          customRender: function(text) {
            return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          slotName: 'tableHeader.company',
          scopedSlots: { title: 'tableHeader.company' },
          align: 'center',
          dataIndex: 'companyCode_dictText'
        },
        {
          slotName: 'tableHeader.category',
          scopedSlots: { title: 'tableHeader.category' },
          align: 'center',
          dataIndex: 'breedClassCode_dictText'
        },
        {
          slotName: 'tableHeader.breed',
          scopedSlots: { title: 'tableHeader.breed' },
          align: 'center',
          dataIndex: 'breedVarietyCode_dictText'
        },
        {
          slotName: 'tableHeader.contractType',
          scopedSlots: { title: 'tableHeader.contractType' },
          align: 'center',
          dataIndex: 'conType_dictText'
        },
        {
          slotName: 'tableHeader.dateOfSigning',
          scopedSlots: { title: 'tableHeader.dateOfSigning' },
          align: 'center',
          dataIndex: 'signDate',
          customRender: function(text) {
            return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          slotName: 'tableHeader.grower',
            scopedSlots: { title: 'tableHeader.grower'},
          align: 'center',
          dataIndex: 'farmerCode_dictText'
        },
        {
          slotName: 'tableHeader.billMaker',
          scopedSlots: { title: 'tableHeader.billMaker' },
          align: 'center',
          dataIndex: 'applyUser_dictText'
        },

        {
          slotName: 'tableHeader.serviceGroup',
          scopedSlots: { title: 'tableHeader.serviceGroup' },
          align: 'center',
          dataIndex: 'serviceGroup_dictText'
        },

        {
          slotName: 'tableHeader.status',
          scopedSlots: { title: 'tableHeader.status' },
          align: 'center',
          dataIndex: 'status_dictText'
        },
        {
          slotName: 'tableHeader.operation',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
        }
      ],
      url: {
        list: '/settlementReceipt/efsStBreedSettle/list',
        delete: '/settlementReceipt/efsStBreedSettle/delete',
        deleteBatch: '/settlementReceipt/efsMdBill/deleteBatch',
        exportXlsUrl: '/settlementReceipt/efsMdBill/exportXls',
        importExcelUrl: 'settlementReceipt/efsMdBill/importExcel',
        submit: '/settlementReceipt/efsStBreedSettle/submit',
        reserve: '/settlementReceipt/efsStBreedSettle/reserveSubmit'

      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    initDictConfig() {
    },
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'breedCode', text: '批次编号', dictCode: '' })
      fieldList.push({ type: 'date', value: 'settlementDate', text: '结算日期' })
      fieldList.push({ type: 'string', value: 'settlementCode', text: '结算单号', dictCode: '' })
      fieldList.push({ type: 'string', value: 'breedVarietyCode', text: '品种编码', dictCode: '' })
      fieldList.push({ type: 'int', value: 'seedlingNumber', text: '投苗数量', dictCode: '' })
      fieldList.push({ type: 'date', value: 'seedlingDate', text: '投苗日期' })
      fieldList.push({ type: 'int', value: 'days', text: '日龄', dictCode: '' })
      fieldList.push({ type: 'date', value: 'saleDate', text: '销售日期' })
      fieldList.push({ type: 'int', value: 'deadAmoyDifference', text: '死淘差异', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'listingRate', text: '上市率', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'meatRatio', text: '肉料比', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'cockAverageWeight', text: '上市公禽均重（只/kg）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'henAverageWeight', text: '上市母禽均重（只/kg）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'averageWeight', text: '上市均重（只/kg）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'recoveryAmount', text: '回收总金额（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'chickenModel', text: '禽苗款（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'feedMoney', text: '饲料款（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'medication', text: '用药款（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'surrogateSupport', text: '基本代养费', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'listingSubsidies', text: '上市率补贴（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'medicineSubsidy', text: '药费补贴（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'otherSubsidies', text: '其他补贴', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'subsidy', text: '补贴小计（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'capitalOccupation', text: '资金占用费（元）', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'depositDeduction', text: '禽苗押金扣款', dictCode: '' })
      fieldList.push({ type: 'BigDecimal', value: 'otherPenalties', text: '其他处罚', dictCode: '' })
      fieldList.push({
        type: 'BigDecimal',
        value: 'surrogateMaintenancePayment',
        text: '实际支付代养费',
        dictCode: ''
      })
      fieldList.push({ type: 'string', value: 'remarks', text: '备注', dictCode: '' })
      fieldList.push({ type: 'string', value: 'createBy', text: '创建人', dictCode: '' })
      fieldList.push({ type: 'date', value: 'createTime', text: '创建日期' })
      fieldList.push({ type: 'string', value: 'updateBy', text: '更新人', dictCode: '' })
      fieldList.push({ type: 'date', value: 'updateTime', text: '更新日期' })
      fieldList.push({ type: 'string', value: 'sysOrgCode', text: '所属部门', dictCode: '' })
      fieldList.push({ type: 'string', value: 'buffer1', text: '拓展属性', dictCode: '' })
      fieldList.push({ type: 'string', value: 'buffer2', text: '拓展属性', dictCode: '' })
      fieldList.push({ type: 'string', value: 'buffer3', text: '拓展属性', dictCode: '' })
      fieldList.push({ type: 'string', value: 'buffer4', text: '拓展属性', dictCode: '' })
      fieldList.push({ type: 'string', value: 'buffer5', text: '拓展属性', dictCode: '' })
      fieldList.push({ type: 'string', value: 'notes', text: '备注', dictCode: '' })
      fieldList.push({ type: 'string', value: 'validFlag', text: '是否有效', dictCode: '' })
      fieldList.push({ type: 'string', value: 'delFlag', text: '是否删除', dictCode: '' })
      fieldList.push({
        type: 'string',
        value: 'status',
        text: '操作状态(10 草稿  20 提交 30通过  40 红冲)',
        dictCode: ''
      })
      this.superFieldList = fieldList
    },
    handleSubmit(id) { // 提交
      if (!this.url.submit) {
        this.$message.error('请设置url.submit属性!')
        return
      }
      postFormAction(this.url.submit, { id: id })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
            this.onClearSelected()
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleReserve(id) { // 冲销
      if (!this.url.reserve) {
        this.$message.error('请设置url.reserve属性!')
        return
      }
      postFormAction(this.url.reserve, { id: id })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
            this.onClearSelected()
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>